<template>
  <!-- 支付完成页面 -->
  <div id="checkoutOver">
    <div class="container" v-if="order.order != null">
      <div class="statusIcon">
        <svg
          t="1695267416846"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="25980"
          :width="viewDevice != 'mobile' ? 150 : 80"
          :height="viewDevice != 'mobile' ? 150 : 80"
        >
          <path
            d="M512 39.822222C250.311111 39.822222 39.822222 250.311111 39.822222 512s210.488889 472.177778 472.177778 472.177778c261.688889 0 472.177778-210.488889 472.177778-472.177778S773.688889 39.822222 512 39.822222z m233.244444 369.777778l-261.688888 284.444444c-11.377778 11.377778-28.444444 17.066667-39.822223 17.066667s-34.133333-5.688889-45.511111-17.066667L278.755556 563.2c-17.066667-22.755556-17.066667-56.888889 5.688888-79.644444 22.755556-22.755556 56.888889-17.066667 79.644445 5.688888L443.733333 568.888889l216.177778-238.933333c22.755556-22.755556 56.888889-22.755556 79.644445-5.688889 22.755556 22.755556 22.755556 62.577778 5.688888 85.333333z"
            fill="#67C23A"
            p-id="25981"
          ></path>
        </svg>
      </div>
      <div class="over">{{ process }}</div>
      <div v-if="status == 'fail'" class="fail">支付失敗，請聯繫客服~</div>
      <div class="baseInfo">
        <div class="orderCard">
          <div v-if="false">{{ tips }}</div>
          <div class="title">訂單詳細資料</div>

          <!-- 商品详情 -->
          <div class="products">
            <el-collapse>
              <el-collapse-item title="商品詳情" name="1">
                <show-cart :list="order.order.item" />
              </el-collapse-item>
            </el-collapse>
          </div>

          <!-- 详细信息 -->
          <div class="info">
            <div class="info-item">
              <span>運費:</span>
              <span
                class="price"
                v-if="order.order.item[order.order.item.length - 1].price != 0"
              >
                {{
                  order.order.item[order.order.item.length - 1].price.replace(
                    /[^0-9.]/g,
                    ""
                  ) | priceFilter
                }}
              </span>
              <span v-else style="color: red">已免運費</span>
            </div>
            <div class="info-item">
              <span>名稱:</span>
              <span>{{ order.order.receiver.name }}</span>
            </div>
            <div class="info-item">
              <span>電話:</span>
              <span>{{ order.order.receiver.phone }}</span>
            </div>
            <div class="info-item" style="height: auto">
              <span>位址:</span>
              <span>{{ order.order.receiver.address }}</span>
            </div>
            <div class="info-item">
              <span>付款狀態:</span>
              <span>{{ payment_status }}</span>
            </div>
            <div class="info-item">
              <span>總計:</span>
              <span class="price">{{
                parseFloat(order.order.total.replace(/[^0-9.]/g, ""))
                  | priceFilter
              }}</span>
            </div>
            <div class="info-item" style="height: auto">
              <span style="min-width: 5em; vertical-align: top"
                >備註:&nbsp;&nbsp;&nbsp;&nbsp;</span
              >
              <span>{{ order.order.receiver.note }}</span>
            </div>
          </div>
        </div>

        <!-- 信息提示 -->
        <div class="simpleCard">
          <div class="card">
            <div class="tips">謝謝，我們已經收到您的訂單.</div>
            <div class="info">
              <div class="info-item">
                <span> 訂單編號:</span>
                <span class="price">{{ order.order.order.order_num }}</span>
              </div>
              <div class="info-item">
                <span> 日期:</span>
                <span class="price">{{ order.order.order.created_at }}</span>
              </div>
              <div class="info-item">
                <span> 總計:</span>
                <span class="price">{{
                  parseFloat(order.order.total.replace(/[^0-9.]/g, ""))
                    | priceFilter
                }}</span>
              </div>
            </div>
            <div class="btns">
              <div
                v-if="
                  order.payment.mode == 'ATMTransfer' &&
                  order.payment.pay_name == '綠界-ATM' &&
                  order.payment.st == 'checking'
                "
                style="
                  background-color: #f0f9eb;
                  color: #67c23a;
                  border-radius: 5px;
                  padding: 0.5em;
                  margin-top: 1em;
                  padding-bottom: 1em;
                "
              >
                <div class="status">
                  <img
                    loading="lazy"
                    src="../../assets/images/pay_load.gif"
                    alt=" 等待繳款中"
                  />
                  <span>等待繳款中...</span>
                </div>
                <div class="code">
                  銀行代號：<span>{{ order.payment.bk_code }}</span>
                </div>
                <div class="code">
                  銀行賬戶：<span>{{ order.payment.bk_acc }}</span>
                </div>
              </div>
              <div>
                <form
                  :method="order.payment.fmethod"
                  :action="order.payment.furl"
                  v-if="
                    order.payment.mode != 'ReceivedPay' &&
                    order.payment.st != 'checking'
                  "
                >
                  <button
                    class="toPay"
                    type="submit"
                    v-if="order.payment.st != 'success'"
                  >
                    前往支付({{ order.payment.pay_name }})<span
                      ><svg
                        t="1695370593001"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2354"
                        width="20"
                        height="20"
                      >
                        <path
                          d="M805.845333 480H224a10.666667 10.666667 0 0 0-10.666667 10.666667v42.666666c0 5.888 4.778667 10.666667 10.666667 10.666667h581.845333v-64z"
                          fill="#262626"
                          p-id="2355"
                        ></path>
                        <path
                          d="M833.28 534.613333a32 32 0 0 0 0-45.226666l-205.781333-205.781334a10.666667 10.666667 0 0 0-15.061334 0l-30.208 30.165334a10.666667 10.666667 0 0 0 0 15.061333L765.44 512l-183.168 183.168a10.666667 10.666667 0 0 0 0 15.104l30.208 30.165333a10.666667 10.666667 0 0 0 15.061333 0l205.781334-205.781333z"
                          fill="#262626"
                          p-id="2356"
                        ></path>
                      </svg>
                    </span>
                  </button>

                  <!--  支付需要-->
                  <template
                    v-if="
                      paymentList.data_list != -1 && paymentList.data_list != 1
                    "
                  >
                    <input
                      v-for="(item, key, index) in paymentList.data_list"
                      :key="index"
                      type="hidden"
                      :name="key"
                      :value="item"
                    />
                  </template>
                </form>
              </div>
              <button @click="toContactLine()">加入Line客服了解寄倉消息</button>
              <button @click="toHome()">查看更多商品</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 未查询到订单时 -->
    <div
      class="container noOrder"
      style="height: 35em; padding-top: 10em"
      v-if="order.order == null || order.order == undefined"
    >
      <span
        ><svg
          height="60"
          node-id="1"
          sillyvg="true"
          template-height="60"
          template-width="60"
          version="1.1"
          viewBox="0 0 37 31"
          width="60"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <defs node-id="29"></defs>
          <g node-id="31">
            <g node-id="32">
              <path
                d="M 12.10 2.32 L 12.57 2.80 L 13.79 4.11 L 13.98 4.30 L 14.17 4.49 L 14.33 4.63 L 14.39 4.69 L 14.40 4.73 L 14.57 4.71 L 15.78 4.51 L 17.25 4.32 L 18.10 4.28 L 18.97 4.32 L 20.11 4.46 L 20.43 4.51 L 20.91 4.59 L 21.36 4.67 L 21.70 4.72 L 21.90 4.73 L 21.83 4.71 L 21.85 4.69 L 22.14 4.38 L 22.23 4.28 L 22.51 3.93 L 23.54 2.62 L 23.87 2.21 L 24.96 1.04 L 25.40 0.76 L 25.78 0.68 L 26.36 0.99 L 27.09 2.06 L 27.67 3.44 L 28.19 5.15 L 28.53 6.89 L 28.65 8.38 L 28.50 8.73 L 28.15 8.88 L 27.79 8.73 L 27.65 8.38 L 27.25 5.66 L 26.45 2.93 L 25.99 1.90 L 25.78 1.68 L 24.46 3.07 L 23.29 4.56 L 22.99 4.92 L 22.33 5.59 L 21.90 5.73 L 21.72 5.72 L 21.20 5.66 L 20.27 5.50 L 19.67 5.41 L 18.89 5.32 L 18.10 5.28 L 17.33 5.32 L 15.94 5.50 L 14.99 5.66 L 14.36 5.73 L 13.99 5.63 L 13.40 5.13 L 12.96 4.68 L 11.95 3.61 L 11.74 3.39 L 10.53 2.25 L 10.13 2.03 L 9.96 2.25 L 9.50 3.64 L 8.56 8.20 L 8.35 8.52 L 7.98 8.61 L 7.66 8.41 L 7.57 8.04 L 7.69 7.33 L 8.29 4.31 L 8.80 2.55 L 9.49 1.32 L 10.13 1.03 L 10.86 1.27 L 12.10 2.32 Z"
                fill="#333333"
                fill-rule="nonzero"
                group-id="1,2"
                id="路径-17"
                node-id="7"
                stroke="none"
                target-height="8.195051"
                target-width="21.07626"
                target-x="7.5697412"
                target-y="0.6830139"
              />
              <path
                d="M 6.33 8.85 L 6.67 8.69 L 7.03 8.82 L 7.20 9.16 L 7.07 9.52 L 5.07 12.05 L 3.69 14.53 L 2.85 17.00 L 2.51 19.50 L 2.65 22.08 L 3.17 23.96 L 4.10 25.50 L 5.49 26.76 L 7.42 27.77 L 10.04 28.48 L 13.55 28.81 L 13.90 28.96 L 14.04 29.32 L 13.88 29.67 L 13.52 29.81 L 9.79 29.45 L 6.97 28.67 L 4.86 27.55 L 3.33 26.13 L 2.27 24.38 L 1.67 22.22 L 1.51 19.46 L 1.88 16.78 L 2.77 14.15 L 4.23 11.51 L 6.33 8.85 Z"
                fill="#333333"
                fill-rule="nonzero"
                group-id="1,2"
                id="路径-18"
                node-id="8"
                stroke="none"
                target-height="21.121674"
                target-width="12.524771"
                target-x="1.5128623"
                target-y="8.6855345"
              />
              <g node-id="33">
                <path
                  d="M 30.21 8.85 L 29.86 8.69 L 29.50 8.82 L 29.34 9.16 L 29.47 9.52 L 31.47 12.05 L 32.85 14.53 L 33.69 17.00 L 34.03 19.50 L 33.88 22.08 L 33.37 23.96 L 32.43 25.50 L 31.05 26.76 L 29.12 27.77 L 26.50 28.48 L 22.99 28.81 L 22.64 28.96 L 22.50 29.32 L 22.66 29.67 L 23.01 29.81 L 26.75 29.45 L 29.57 28.67 L 31.67 27.55 L 33.21 26.13 L 34.27 24.38 L 34.87 22.22 L 35.02 19.46 L 34.66 16.78 L 33.77 14.15 L 32.31 11.51 L 30.21 8.85 Z"
                  fill="#333333"
                  fill-rule="nonzero"
                  group-id="1,2,3"
                  id="路径-18备份"
                  node-id="9"
                  stroke="none"
                  target-height="21.121675"
                  target-width="12.524769"
                  target-x="22.500076"
                  target-y="8.685534"
                />
              </g>
              <g node-id="34">
                <path
                  d="M 0.53 14.03 L 0.62 14.05 L 4.62 15.05 L 4.93 15.27 L 4.99 15.65 L 4.79 15.94 L 4.47 16.03 L 4.38 16.02 L 0.38 15.02 L 0.07 14.79 L 0.01 14.41 L 0.21 14.13 L 0.53 14.03 Z"
                  fill="#333333"
                  fill-rule="nonzero"
                  group-id="1,2,4"
                  id="直线-2"
                  node-id="11"
                  stroke="none"
                  target-height="1.9981089"
                  target-width="4.9701424"
                  target-x="0.01492875"
                  target-y="14.033128"
                />
                <path
                  d="M 4.44 16.54 L 4.81 16.64 L 5.00 16.97 L 4.92 17.31 L 4.65 17.51 L 4.56 17.53 L 0.56 18.03 L 0.19 17.93 L 0.00 17.59 L 0.08 17.26 L 0.35 17.06 L 0.44 17.04 L 4.44 16.54 Z"
                  fill="#333333"
                  fill-rule="nonzero"
                  group-id="1,2,4"
                  id="直线-2备份"
                  node-id="12"
                  stroke="none"
                  target-height="1.4922771"
                  target-width="4.992278"
                  target-x="0.00386106"
                  target-y="16.536043"
                />
              </g>
              <g node-id="35">
                <path
                  d="M 36.47 14.03 L 36.38 14.05 L 32.38 15.05 L 32.07 15.27 L 32.01 15.65 L 32.21 15.94 L 32.53 16.03 L 32.62 16.02 L 36.62 15.02 L 36.93 14.79 L 36.99 14.41 L 36.79 14.13 L 36.47 14.03 Z"
                  fill="#333333"
                  fill-rule="nonzero"
                  group-id="1,2,5"
                  id="直线-2备份-2"
                  node-id="14"
                  stroke="none"
                  target-height="1.9981089"
                  target-width="4.9701424"
                  target-x="32.01493"
                  target-y="14.033128"
                />
                <path
                  d="M 32.56 16.54 L 32.19 16.64 L 32.00 16.97 L 32.08 17.31 L 32.35 17.51 L 32.44 17.53 L 36.44 18.03 L 36.81 17.93 L 37.00 17.59 L 36.92 17.26 L 36.65 17.06 L 36.56 17.04 L 32.56 16.54 Z"
                  fill="#333333"
                  fill-rule="nonzero"
                  group-id="1,2,5"
                  id="直线-2备份-3"
                  node-id="15"
                  stroke="none"
                  target-height="1.4922771"
                  target-width="4.992279"
                  target-x="32.00386"
                  target-y="16.536043"
                />
              </g>
              <path
                d="M 10.59 16.53 L 11.30 16.24 L 11.59 15.53 L 11.30 14.83 L 10.59 14.53 L 9.89 14.83 L 9.59 15.53 L 9.89 16.24 L 10.59 16.53 Z"
                fill="#333333"
                fill-rule="evenodd"
                group-id="1,2"
                id="椭圆形"
                node-id="16"
                stroke="none"
                target-height="1.999999"
                target-width="2"
                target-x="9.592839"
                target-y="14.532182"
              />
              <path
                d="M 8.00 20.03 L 8.78 19.87 L 9.41 19.45 L 9.84 18.82 L 10.00 18.03 L 9.84 17.25 L 9.41 16.62 L 8.78 16.19 L 8.00 16.03 L 7.22 16.19 L 6.59 16.62 L 6.16 17.25 L 6.00 18.03 L 6.16 18.82 L 6.59 19.45 L 7.22 19.87 L 8.00 20.03 Z"
                fill="#f6b2b1"
                fill-rule="evenodd"
                group-id="1,2"
                id="椭圆形备份-6"
                node-id="17"
                stroke="none"
                target-height="4.000002"
                target-width="4"
                target-x="6"
                target-y="16.03218"
              />
              <path
                d="M 28.00 20.03 L 28.78 19.87 L 29.41 19.45 L 29.84 18.82 L 30.00 18.03 L 29.84 17.25 L 29.41 16.62 L 28.78 16.19 L 28.00 16.03 L 27.22 16.19 L 26.59 16.62 L 26.16 17.25 L 26.00 18.03 L 26.16 18.82 L 26.59 19.45 L 27.22 19.87 L 28.00 20.03 Z"
                fill="#f6b2b1"
                fill-rule="evenodd"
                group-id="1,2"
                id="椭圆形备份-7"
                node-id="18"
                stroke="none"
                target-height="4.000002"
                target-width="4"
                target-x="26"
                target-y="16.03218"
              />
              <path
                d="M 25.37 16.53 L 26.07 16.24 L 26.37 15.53 L 26.07 14.83 L 25.37 14.53 L 24.66 14.83 L 24.37 15.53 L 24.66 16.24 L 25.37 16.53 Z"
                fill="#333333"
                fill-rule="evenodd"
                group-id="1,2"
                id="椭圆形备份-5"
                node-id="19"
                stroke="none"
                target-height="1.999999"
                target-width="2"
                target-x="24.367285"
                target-y="14.532182"
              />
              <path
                d="M 21.57 12.42 L 21.07 11.88 L 20.81 10.93 L 20.92 10.56 L 21.26 10.38 L 21.63 10.49 L 21.81 10.83 L 21.93 11.38 L 22.07 11.55 L 22.30 11.59 L 22.83 11.42 L 23.22 11.41 L 23.50 11.67 L 23.51 12.06 L 23.25 12.34 L 22.30 12.59 L 21.57 12.42 Z"
                fill="#333333"
                fill-rule="nonzero"
                group-id="1,2,6"
                id="直线-2备份-7"
                node-id="20"
                stroke="none"
                target-height="2.2064629"
                target-width="2.697939"
                target-x="20.811304"
                target-y="10.382269"
              />
              <path
                d="M 14.43 12.42 L 14.93 11.88 L 15.19 10.93 L 15.08 10.56 L 14.74 10.38 L 14.37 10.49 L 14.19 10.83 L 14.07 11.38 L 13.93 11.55 L 13.70 11.59 L 13.17 11.42 L 12.78 11.41 L 12.50 11.67 L 12.49 12.06 L 12.75 12.34 L 13.70 12.59 L 14.43 12.42 Z"
                fill="#333333"
                fill-rule="nonzero"
                group-id="1,2,7"
                id="直线-2备份-8"
                node-id="21"
                stroke="none"
                target-height="2.2064629"
                target-width="2.6979408"
                target-x="12.490759"
                target-y="10.382269"
              />
              <path
                d="M 18.00 16.03 L 18.68 15.86 L 18.86 15.53 L 18.68 15.20 L 18.00 15.03 L 17.34 15.20 L 17.18 15.53 L 17.34 15.86 L 18.00 16.03 Z"
                fill="#333333"
                fill-rule="evenodd"
                group-id="1,2,8"
                id="椭圆形备份-8"
                node-id="23"
                stroke="none"
                target-height="0.99999905"
                target-width="1.6832447"
                target-x="17.177969"
                target-y="15.032182"
              />
              <path
                d="M 18.50 16.31 L 18.34 17.09 L 17.92 17.72 L 17.29 18.15 L 16.50 18.31 L 15.75 18.16 L 15.14 17.77 L 14.70 17.19 L 14.51 16.46 L 14.50 16.31 L 14.50 15.69 L 14.65 15.33 L 15.00 15.19 L 15.32 15.30 L 15.49 15.60 L 15.50 15.69 L 15.50 16.31 L 15.79 17.02 L 16.50 17.31 L 17.17 17.05 L 17.50 16.43 L 17.50 16.31 L 17.50 15.69 L 17.65 15.33 L 18.00 15.19 L 18.32 15.30 L 18.49 15.60 L 18.50 15.69 L 18.50 16.31 Z"
                fill="#333333"
                fill-rule="nonzero"
                group-id="1,2,8,10"
                id="矩形"
                node-id="24"
                stroke="none"
                target-height="3.1232195"
                target-width="4"
                target-x="14.501881"
                target-y="15.186574"
              />
              <path
                d="M 21.50 16.31 L 21.34 17.09 L 20.92 17.72 L 20.29 18.15 L 19.50 18.31 L 18.75 18.16 L 18.14 17.77 L 17.70 17.19 L 17.51 16.46 L 17.50 16.31 L 17.50 15.69 L 17.65 15.33 L 18.00 15.19 L 18.32 15.30 L 18.49 15.60 L 18.50 15.69 L 18.50 16.31 L 18.79 17.02 L 19.50 17.31 L 20.17 17.05 L 20.50 16.43 L 20.50 16.31 L 20.50 15.69 L 20.65 15.33 L 21.00 15.19 L 21.32 15.30 L 21.49 15.60 L 21.50 15.69 L 21.50 16.31 Z"
                fill="#333333"
                fill-rule="nonzero"
                group-id="1,2,8,11"
                id="矩形备份-11"
                node-id="25"
                stroke="none"
                target-height="3.1232195"
                target-width="4"
                target-x="17.50188"
                target-y="15.186574"
              />
              <path
                d="M 10.35 4.31 L 9.97 4.73 L 9.59 5.91 L 9.37 7.11 L 9.38 7.58 L 9.52 7.77 L 10.29 7.58 L 11.43 7.00 L 12.07 6.38 L 11.74 5.60 L 10.97 4.68 L 10.35 4.31 Z"
                fill="#f6b2b1"
                fill-rule="evenodd"
                group-id="1,2"
                id="路径-19"
                node-id="26"
                stroke="none"
                target-height="3.4659634"
                target-width="2.7004957"
                target-x="9.365987"
                target-y="4.306999"
              />
              <path
                d="M 25.72 4.31 L 26.10 4.73 L 26.48 5.91 L 26.70 7.11 L 26.69 7.58 L 26.55 7.77 L 25.78 7.58 L 24.64 7.00 L 24.00 6.38 L 24.33 5.60 L 25.10 4.68 L 25.72 4.31 Z"
                fill="#f6b2b1"
                fill-rule="evenodd"
                group-id="1,2,9"
                id="路径-19备份"
                node-id="27"
                stroke="none"
                target-height="3.4659634"
                target-width="2.7004986"
                target-x="24.00402"
                target-y="4.306999"
              />
            </g>
          </g>
        </svg>
      </span>
      <br />
      未查詢到訂單哦~
    </div>
  </div>
</template>

<script>
import windowSize from "@/mixins/windowSize";
import { mapActions, mapMutations, mapState } from "vuex";
import ShowCart from "@/components/checkout/ShowCart.vue";
import checkoutService from "@/store/service/checkout-service";
export default {
  name: "CheckoutOverView",
  components: { ShowCart },
  mixins: [windowSize],
  data() {
    return {
      tips: "陪你一起養貓貓",
      process: "",
      paymentList: [],
      status: "",
      timer: null,
      active: true,
      first: true,
    };
  },
  computed: {
    ...mapState("checkout", ["order"]),
    ...mapState("home", ["websiteConfig"]),
    ...mapState("headerNav", ["getfb"]),
    payment_status() {
      return this.order.order.payment.status_name;
    },
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      async handler(newVal, oldVal) {
        if (newVal.params.order_num) {
          if (typeof window !== "undefined") {
            this.$loading_page(true);
            try {
              await this.updateOrder(this.$route.params.order_num).then((e) => {
                if (e.payment.st && e.payment.st == "checking") {
                  this.call_back(e.order.order.order_num);
                }
                if (this.order.order != null) {
                  this.process = this.order.order.process;
                  this.paymentList = this.order.payment;
                  this.status = this.order.payment.st;
                }
              });
            } catch (error) {
              console.log(error);
            }

            this.$loading_page(false);
          }
        }
      },
    },
  },
  methods: {
    ...mapActions("checkout", ["updateOrder", "updatePayment"]),
    ...mapMutations("checkout", ["UPDATE_PAYMENT"]),
    // 前往首页
    toHome() {
      this.$router.push({
        path: "/",
      });
    },
    toContactLine() {
      if (this.websiteConfig != null) {
        this.websiteConfig.company_info.forEach((element) => {
          if (element.key == "Line_Link") {
            window.open(element.value, "_blank");
          }
        });
      }
    },
    async call_back(order_num) {
      let res = await checkoutService.get_order_payment(order_num);
      this.updatePayment(res)
        .then((e) => {
          if (e.payment.st == "checking") {
            // 如果状态为 "checking"，等待 10 秒后再次请求

            this.timer = setTimeout(() => {
              if (this.active) {
                this.call_back(e.order.order.order_num);
              }
              clearTimeout(this.timer);
            }, 10000); // 10 秒
          } else {
            // 状态不是 "checking"，结束循环
            // 在这里处理不是 "checking" 的状态
            this.updateOrder(this.$route.params.order_num);
          }
          // console.log(1);
        })
        .catch((error) => {
          // 处理错误
          console.error("An error occurred:", error);
        });
    },
  },
  beforeDestroy() {
    this.active = false;
    clearTimeout(this.timer);
  },
};
</script>

<style lang="less" scoped>
#checkoutOver {
  height: 100%;
  padding: 2em 0;
  background-color: #eeeeee;
  // min-height: 50em;
  .mobile({
    padding: 0;
  });

  .container {
    padding: 3em 2em;
    border-radius: 12px;
    background-color: #fff;
    .fail {
      color: red;
    }

    .mobile({
      padding: 1em;
      border-radius: 0;
      margin: 0;
  });
  }
  .noOrder {
    .mobile({
      border-radius: 0;
    });
  }

  .over {
    margin: 0 0 1em;
    color: #777777;
    font-size: 0.8em;
    font-family: @font-family-bold;
  }

  .baseInfo {
    .flex-mixin(row, flex-start, center);

    .mobile({
    .flex-mixin(column-reverse, center, center);
  });

    .tablet({
  .flex-mixin(column-reverse, center, center);
});

    .title {
      font-family: @font-family-bold;
      font-size: 1.5em;
      height: 3em;
      line-height: 3em;
    }

    .price {
      font-family: @font-family-bold;
    }
  }

  .info-item {
    .flex-mixin(row, space-between, center);
    height: 3em;
    border-bottom: 1px solid #ebeef5;

    > span:nth-child(1) {
    }
  }

  .orderCard {
    text-align: left;
    padding: 1em;
    overflow: hidden;
    width: 60%;

    .mobile({
    width: 100%;
    padding: 0.2em
  });

    .tablet({
  width: 100%;
  padding: 0.2em
});
  }

  .simpleCard {
    background-color: #fff;
    margin-left: 5em;

    .mobile({
    margin: 0
  });

    .tablet({
  margin: 0
});

    .tips {
      font-size: 0.8em;
      color: balck;
    }

    .card {
      width: 20em;
      border: 1px solid #ebeef5;
      border-radius: 10px;
      padding: 2em;
      text-align: left;

      .mobile({
    width: 100%;
    padding: 2em;
    font-size: 0.8em
  });

      .tablet({
  width: 100%;
  padding: 2em;
});

      .btns {
        .flex-mixin(column, center, right);

        .status {
          .flex-mixin(row,center,center);
          img {
            flex: 2;
            max-width: 80px;
          }
          span {
            flex: 8;
          }
        }
        .code {
          padding-left: 1em;
          font-size: 0.8em;
          span {
            font-weight: bold;
          }
        }
        form {
          width: 100%;
          transition: all 0.2s linear;

          &:hover {
            opacity: 0.8;
          }
        }

        .toPay {
          cursor: pointer;
          width: 100%;
          border: 0;
          border-radius: 5px;
          background-color: red;
          color: white;
          text-align: center;
          height: 2.5em;
          line-height: 2.5em;

          span {
            position: relative;
            top: 0.25em;

            path {
              fill: white;
            }

            .mobile({
        top:0.4em;
      });
          }
        }

        button {
          width: 100%;
          height: 2.5em;
          border: 1px solid #ca7658;
          background-color: #fff;
          color: #ca7658;
          margin-top: 1em;
          border-radius: 5px;
          transition: all 0.2s linear;

          .mobile({
    height: 3em;
  });

          &:hover {
            cursor: pointer;
            opacity: 0.8;
          }

          &:nth-child(2) {
            background-color: #ca7658;
            color: white;
          }
        }
      }

      &:hover {
        box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>
